import { Pipe, type PipeTransform } from '@angular/core';
import { recurrenceWords } from '@sharedlib/common/utils/rrule-utils';

/**
 * Renders an RRULE string as the Calendar's recurrence wording (e.g. `"Monthly on the fourth Thursday"`),
 * through the shared `recurrenceWords`, so the event's header, Repeats field, Details and cards read one way;
 * the clock time is shown separately by the host view. Pure — recomputes only when the input changes.
 */
@Pipe({
  name: 'recurrenceText',
  standalone: true,
})
export class RecurrenceTextPipe implements PipeTransform {
  public transform(recurrence: string | null | undefined, fallback = ''): string {
    return recurrenceWords(recurrence, fallback);
  }
}
